export default "__VITE_ASSET__318521ed__"